module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/account.component.scss
// module id = ./src/app/components/account/account.component.scss
// module chunks = main